import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import { Link } from "react-router";
import ConfirmActions from "../../../Action/Actions/ConfirmActions";
import SignoutActions from "../../../Action/Actions/SignoutActions";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';

import ConfirmWillMount from "../../../Middleware/Middlewares/ConfirmWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";

class Invite extends Component {

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CONFIRM_CLEAR;

  private types: {
    readonly standard: string,
    readonly confirm: string,
    readonly reset: string,
    expired: string,
    invite: string
  } = {
    standard: "standard",
    confirm: "confirm",
    reset: "reset",
    expired: "expired",
    invite: "invite"
  };

  public state: {
    email: string,
    id: number,
    type: any,
    tokenAlreadyUsed: boolean
  } = {
    email: "",
    id: null,
    type: this.types.standard,
    tokenAlreadyUsed: false
  };

  protected middlewares: MiddlewareInterface[] = [
    ConfirmWillMount
  ];

  constructor(public props) {
    super(props);

    this.updatePassword = this.updatePassword.bind(this);
    this.updateConfirmPassword = this.updateConfirmPassword.bind(this);
    this.renderInitialConfirmPage = this.renderInitialConfirmPage.bind(this);
    this.renderEnterPasswordForm = this.renderEnterPasswordForm.bind(this);
    this.renderSigninForm = this.renderSigninForm.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

    /**
     * This is the hotfix for react-router issue, that cause the problem of
     * infinite rerendering of component: routeParams(received for react-router Route) props
     * updates few times per sec
     * 
     * TODO: Should be fixed by installing the new version of react-router-dom
     * */ 
    shouldComponentUpdate(newProps, nextState) {
      if (this.state !== nextState) return true;
      const isPropsStringsSame = JSON.stringify(newProps) === JSON.stringify(this.props)
      if (
        isPropsStringsSame
        && newProps.routeParams !== this.props.routeParams
      ) {
        return false;
      }
  
      return !isPropsStringsSame;
    }

  protected updatePassword(e) {
    this.props.dispatch(ConfirmActions.updatePassword(e.target.value));
  }

  protected updateConfirmPassword(e) {
    this.props.dispatch(ConfirmActions.updateConfirmPassword(e.target.value));
  }

  protected signin() {
    this.props.dispatch(ConfirmActions.signinRequest(this.props.app.session.user.id, this.props.confirm.password, this.props.app.session.user.agencyId, this.props.confirm.user.email || this.state.email));
  }

  protected signout() {
    this.props.dispatch(SignoutActions.request());
  }

  protected confirmAccount() {
    this.props.dispatch(
      ConfirmActions.confirmAccountRequest(
        this.props.confirm.password,
        this.props.confirm.confirmPassword,
        this.props.location?.query?.token,
        "inviteUser"
      )
    );
  }

  protected resetPassword() {
    this.props.dispatch(
      ConfirmActions.resetPasswordRequest(
        this.props.confirm.password,
        this.props.confirm.confirmPassword,
        this.props.location?.query?.token
      )
    );
  }

  protected resendConfirmationMail() {
    if (this.state.id !== null) {
      this.props.dispatch(ConfirmActions.resendConfirmationMailRequest(this.state.id));
    } else {
      this.props.dispatch(ConfirmActions.resendConfirmationMailRequest(this.props.app.session.user));
    }
  }

  protected resendInviteMail() {
    if (this.state.id !== null) {
      this.props.dispatch(ConfirmActions.resendInviteMailRequest(this.state.id));
    } else {
      this.props.dispatch(ConfirmActions.resendInviteMailRequest(this.props.app.session.user));
    }
  }

  protected closePopup() {
    this.props.dispatch(ConfirmActions.closePopupStart());
  }

  protected renderResendToken() {
    return (
      <div className="state-auth">
        <div className="box component-confirm action-confirm">

          <div className="image-container">
            {this.image.getAvatar("info", { size: 62 })}
          </div>

          <h2>{this.trans("title-invite-link-expired")}</h2>

          <p>{this.trans("title-confirmation-link-expired-footer", { email: this.state.email } )}</p>

          <Button
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={this.resendInviteMail.bind(this)}
            style={{ margin: "20px 0" }}
          >
            {this.trans("button-send-invite-mail")}
          </Button>

          <Link to="/auth/check-email">
            {this.trans("button-back-to-signin")}
          </Link>

          <PromptDialog
            {...this.props}
            content={this.props.confirm.popupMessage}
            openLeavePrompt={this.props.confirm.popup}
            onlyPositiveButton={true}
            prioritizeClosing={true}
            withoutDefaultDilaogButtons={false}
            actions={[
              <Button
                variant="contained"
                color="primary"
                onClick={this.closePopup}
              >
                {this.trans("button-close")}
              </Button>
            ]}
            hideCross={true}
          />

        </div>
      </div>
    );
  }

  protected renderInitialConfirmPage() {
    return (
      <div className="state-auth">
        <div className="box component-confirm action-confirm">

          <div className="image-container">
            {this.image.getAvatar("info", { size: 62 })}
          </div>

          <h2>{this.trans("title-account-not-confirmed-header")}</h2>

          <p>{this.trans("title-account-not-confirmed-footer", { email: this.props.app.session.user.email } )}</p>

          <Button
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={this.resendConfirmationMail.bind(this)}
            style={{ margin: "20px 0" }}
          >
            {this.trans("button-send-confirmation-mail")}
          </Button>

          <Link to="/auth/check-email">
            {this.trans("button-back-to-signin")}
          </Link>

          <PromptDialog
            {...this.props}
            content={this.props.confirm.popupMessage}
            openLeavePrompt={this.props.confirm.popup}
            onlyPositiveButton={true}
            prioritizeClosing={true}
            withoutDefaultDilaogButtons={false}
            actions={[
              <Button
                variant="contained"
                color="primary"
                onClick={this.closePopup}
              >
                {this.trans("button-close")}
              </Button>
            ]}
            hideCross={true}
          />

        </div>
      </div>
    );
  }

  protected renderEnterPasswordForm() {
    return (
      <div className="state-auth">
        <div className="box component-confirm action-enter">
          <div style={{textAlign: "center"}}>
            <h1>Casadesk</h1>

            {!this.state.tokenAlreadyUsed && (
              <React.Fragment>
                <div className="main-text-of-step" style={{margin: "5px 0 -10px 0"}}>
                  {this.trans("confirmnewpassword/main-text")}
                </div>
                
                <div className="info-text-gray">
                  {this.trans("confirmnewpassword/info-text")}
                </div>
              </React.Fragment>
            )}
          </div>

          <form>
            {
              this.state.tokenAlreadyUsed ?
              <p className="error-element">{this.trans("be_token_already_used")}</p>              
              :
              <div>
                <TextField
                  className="form-element"
                  autoFocus={true}
                  label={this.trans("label-password")}
                  type="password"
                  fullWidth={true}
                  onKeyPress={(e) => {(e.key ==="Enter" ? this.confirmAccount() : null)}}
                  value={this.props.confirm.password}
                  onChange={this.updatePassword}
                  variant="standard"
                  error={!!this.props.confirm.popupMessage}
                />
                {!!this.props.confirm.popupMessage && <div className="component-error-text">{this.props.confirm.popupMessage}</div>}

                <TextField
                  className="form-element"
                  label={this.trans("label-confirm-password")}
                  type="password"
                  fullWidth={true}
                  onKeyPress={(e) => {(e.key ==="Enter" ? this.confirmAccount() : null)}}
                  value={this.props.confirm.confirmPassword}
                  onChange={this.updateConfirmPassword}
                  variant="standard"
                  error={!!this.props.confirm.popupMessage}
                />
                {!!this.props.confirm.popupMessage && <div className="component-error-text">{this.props.confirm.popupMessage}</div>}

                <Button
                  variant="contained"
                  color="primary"
                  fullWidth={true}
                  onClick={this.confirmAccount.bind(this)}
                  disabled={this.props.confirm.isFetching}
                  style={{ margin: "20px 0" }}
                >
                  {this.props.confirm.isFetching === true ? this.trans("button-saving") : this.trans("button-save")}
                </Button>
              </div>
            }
          </form>
        </div>
      </div>
    );
  }

  protected renderSigninForm() {
    return (
      <div className="state-auth">
        <div className="box component-confirm action-signin">

          <div style={{textAlign: "center"}}>
            <h1>Casadesk</h1>

            <div className="main-text-of-step" style={{margin: "5px 0 -10px 0"}}>
              {this.trans("resetconfirmnewpassword/main-text")}
            </div>
            
            <div className="info-text-gray">
              {this.trans("resetconfirmnewpassword/info-text")}
            </div>
          </div>

          <form onSubmit={e => e.preventDefault()}>
            <TextField
              autoComplete="off"
              className="form-element"
              autoFocus={true}
              label={this.trans("label-password")}
              type="password"
              fullWidth={true}
              value={this.props.confirm.password}
              onChange={this.updatePassword}
              onKeyPress={e => e.key === "Enter" ? this.signin() : null}
              variant="standard"
              error={!!this.props.confirm.popupMessage}
            />
            {!!this.props.confirm.popupMessage && <div className="component-error-text">{this.props.confirm.popupMessage}</div>}

            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              onClick={this.signin.bind(this)}
              disabled={this.props.confirm.isFetching}
              style={{ margin: "20px 0" }}
            >
              {this.props.confirm.isFetching === true ? this.trans("button-please-wait") : this.trans("signin")}
            </Button>

            <div>
              <Link to="/auth/check-email">{this.trans("link-back-to-signin")}</Link>
              <Link to="/auth/forgot-password">{this.trans("forgot-password")}?</Link>
            </div>
          </form>
        </div>
      </div>
    );
  }

  public render() {
    switch (this.state.type) {
      case this.types.standard:
        return this.props.app.session.user.contactStatusId === 1 ?
        this.renderSigninForm() : this.renderInitialConfirmPage();

      case this.types.invite:
      case this.types.confirm:
        return this.renderEnterPasswordForm();
      case this.types.expired:
        return this.renderResendToken();

      default:
        return;
    }
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    confirm: state.confirm,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Invite
);
